/** default endpoints */
export const WpEndpoint = {
  posts: '/wp-json/wp/v2/posts/',
  revisions: '/wp-json/wp/v2/revisions',
  users: '/wp-json/wp/v2/users/',
  categories: '/wp-json/wp/v2/categories/',
  tags: '/wp-json/wp/v2/tags',
  pages: '/wp-json/wp/v2/pages/',
  comments: '/wp-json/wp/v2/comments/',
  media: '/wp-json/wp/v2/media/',
  statuses: '/wp-json/wp/v2/statuses/',
  taxonomies: '/wp-json/wp/v2/taxonomies/',
  types: '/wp-json/wp/v2/types/',
  authentication: '/wp-json/wp/v2/users/me?_envelope'
};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
